import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MenuService } from '../services/menu.service';

@Component({
  selector: 'app-header',
  imports: [CommonModule, FormsModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  searchQuery: string = ''; // For search input binding
  showSearchBar = false;

  // Profile dropdown
  profileDropdownOpen = false;
  userFirstName: string = '';
  userProfileImage: string = '';

  constructor(private router: Router, private menuService: MenuService) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // ✅ Show search only on /dashboard route
        this.showSearchBar = event.urlAfterRedirects === '/dashboard';
      });
  }

  ngOnInit(): void {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    this.userFirstName = userData?.user_details?.[1]?.first_name || 'User';
    this.userProfileImage = userData?.profile_image || 'https://estcdndev.blob.core.windows.net/document/assets/user.png';
  }

  isContentRouteActive(): boolean {
    return this.router.url.startsWith('/content');
  }

  toggleMobileMenu() {
    this.menuService.toggleMenu();
  }

  showMobileMenuButton(): boolean {
    return this.router.url !== '/dashboard';
  }

  toggleProfileDropdown() {
    this.profileDropdownOpen = !this.profileDropdownOpen;
  }

  logout() {
    localStorage.removeItem('userData');
    this.router.navigate(['/login']);
  }
}
